module.exports = "<div class=\"rc-table-card__warn-text\" [ngClass]=\"className\" *ngFor=\"let message of messages\">{{message}}</div>\n";